import React from "react";
import { Select } from "antd";

import styles from "./styles/SortOption.scss";
import { AdsSortOptionText, AdsSortOption } from "../../models";
import { getIconUrl } from "../../services/asset";
import SortOptionMobile from "./SortOptionMobile";

function SortOption({
  onSortClick,
  isMobile,
  selectedOption,
  classNameDesktop,
  includeSortOptionClassName,
  options,
}) {

  return !isMobile ? (
    <div className={`${styles.sortOptionContainer} ${classNameDesktop}`}>
      <Select
        onChange={value => onSortClick(value)}
        value={selectedOption}
        className={`${styles.sortOption} ${includeSortOptionClassName ? "sort-option" : ""}`}
      >
        {options.map(option => (
          <Select.Option
            key={option.value}
            value={option.value}
            title={option.name}
            // @ts-ignore
            className={styles.item}
          >
            {option.iconId ? (
              <img
                alt={option.name}
                src={getIconUrl(option.iconId)}
                className={styles.sortIcon}
              />
            ) : null}
            {option.name}
          </Select.Option>
        ))}
      </Select>
    </div>
  ) : (
    <SortOptionMobile
      onSortClick={onSortClick}
      selectedOption={selectedOption}
    />
  );
}

SortOption.defaultProps = {
  isMobile: false,
  selectedOption: AdsSortOption.DateDesc,
  classNameDesktop: "",
  includeSortOptionClassName: true,
  options: AdsSortOptionText,
};

export default SortOption;



// WEBPACK FOOTER //
// ./src/components/SortOption/index.tsx